export default __webpack_public_path__ + "static/media/red1.31965134.jpg";